import { SetModelJsonResource } from "@/types/setTypes";
import { displayRelativeTime } from "@/lib/dateUtils";
import { displayWeight } from "@/lib/utils";
import { useEffectiveUser } from "@/hooks/useEffectiveUser";

interface OneSetCardProps {
  set: SetModelJsonResource;
}

export function OneSetCard({ set }: OneSetCardProps) {
  const { user } = useEffectiveUser();

  if (!user) {
    return null;
  }

  return (
    <div className="flex items-center justify-between p-4 rounded-md   bg-bg-light border border-bd-overlay">
      <div className="flex flex-col items-start">
        <h3 className="font-medium text-sm text-primary">
          {set.exercise?.name}
        </h3>

        {/* Stats row */}
        <p className="text-tx-default text-sm ">
          {user &&
            displayWeight(
              set.weight_lb,
              set.weight_kg,
              user.preferred_weight_unit
            )}
          <span className="text-tx-muted mx-1">x</span>
          {set.reps} reps
        </p>
      </div>

      {/* Time information */}
      <div className="px-2 py-0.5 rounded-full text-xs bg-white text-tx-muted">
        <span>{displayRelativeTime(set.claimed_train_at)}</span>
      </div>
    </div>
  );
}
